import { Box } from '@mui/material';

import { useSxStyles } from './useStyles';

export enum LabelType {
  employment = 'employment',
  employmentDetails = 'employmentDetails',
  newEmployment = 'newEmployment',
}

type Props = {
  labelType: LabelType;
  labelValue: string;
};

export const EmploymentPendingLabel = ({
  labelType,
  labelValue,
}: Props): JSX.Element => {
  const sxStyles = useSxStyles();
  const mainStyle = sxStyles.label;

  const getParticularStyle = () => {
    switch (labelType) {
      case LabelType.employmentDetails:
        return sxStyles.employmentDetails;
      case LabelType.newEmployment:
        return sxStyles.newEmployment;
      case LabelType.employment:
      default:
        return sxStyles.employment;
    }
  };

  return (
    <Box component="span" sx={{ ...mainStyle, ...getParticularStyle() }}>
      {labelValue}
    </Box>
  );
};
